export const generateUniformWaypoints = (coordinates, interval = 1.0) => {
  const waypoints = [];

  // 유효한 좌표만 필터링
  const validCoordinates = coordinates.filter(
    (coord) =>
      !isNaN(coord.x) &&
      !isNaN(coord.y) &&
      !isNaN(coord.z) &&
      isFinite(coord.x) &&
      isFinite(coord.y) &&
      isFinite(coord.z)
  );

  // 유효한 좌표 사이에 균일한 간격의 중간점 생성
  for (let i = 0; i < validCoordinates.length - 1; i++) {
    const start = validCoordinates[i];
    const end = validCoordinates[i + 1];

    // 거리 계산 전 유효성 검사
    if (isNaN(start.x) || isNaN(end.x)) continue;

    // 두 좌표 사이의 거리 계산
    const distance = Math.sqrt(
      Math.pow(end.x - start.x, 2) + Math.pow(end.y - start.y, 2)
    );

    // 거리가 0이거나 너무 작으면 건너뛰기
    if (distance < 0.001) continue;

    // 일정 간격으로 중간점 생성
    const numPoints = Math.ceil(distance / interval);
    for (let j = 0; j <= numPoints; j++) {
      const t = j / numPoints;
      const x = start.x + (end.x - start.x) * t;
      const y = start.y + (end.y - start.y) * t;
      const z = start.z + (end.z - start.z) * t;
      waypoints.push({ x, y, z });
    }
  }

  return waypoints;
};
